import {useQuery} from '@tanstack/react-query';
import axios from 'axios';

import {referenceDataQueryKeys} from './referenceDataQueryKeys';

const useProSectors = () => {
  const {data, isLoading, error, refetch} = useQuery({
    queryKey: referenceDataQueryKeys.sectors(),
    queryFn: async () => await axios.get('/api/onboarding/sectors').then((res) => res.data),
    staleTime: Infinity,
  });

  return {data, isLoading, error, refetch};
};

export default useProSectors;
